// Server-derived status is preferred; date checks also keep an open staff page honest.
const validStates = new Set(['active', 'inactive', 'expired', 'lifetime']);
function expiration(member) {
  for (const value of [member.membership_expires_at, member.expiration_date]) {
    if (!value) continue;
    const text = String(value);
    const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(text);
    if (parts) {
      const [year, month, day] = parts.slice(1).map(Number);
      const check = new Date(Date.UTC(year, month - 1, day));
      if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) continue;
    }
    const time = Date.parse(text);
    if (Number.isFinite(time)) return time;
  }
  return null;
}
export function getMembershipStatus(member = {}, now = Date.now()) {
  const stored = String(member.membership_status || '').trim().toLowerCase();
  const server = member.effective_membership_status;
  if (server === 'lifetime' || stored === 'lifetime' || member.lifetime_member === true || member.is_lifetime_member === true) return 'lifetime';
  const expiry = expiration(member);
  if (expiry !== null && now >= expiry) return 'expired';
  if (validStates.has(server)) return server;
  if (stored === 'active' || member.active_member === true || member.is_active_member === true) return 'active';
  return stored === 'expired' ? 'expired' : 'inactive';
}
